var React = require('react');

function SharetwitterhoverInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#0076ae","key":0}),React.createElement("path",{"d":"M13,23a9.27,9.27,0,0,0,9.33-9.21h0v-.55A7.1,7.1,0,0,0,24,11.54a6.89,6.89,0,0,1-1.89.52,3.26,3.26,0,0,0,1.44-1.82,6.75,6.75,0,0,1-2.08.8,3.28,3.28,0,0,0-5.67,2.25,2.74,2.74,0,0,0,.08.75,9.34,9.34,0,0,1-6.76-3.43,3.28,3.28,0,0,0,1,4.37,3.08,3.08,0,0,1-1.48-.41h0a3.29,3.29,0,0,0,2.63,3.22,3.13,3.13,0,0,1-.86.12,3.18,3.18,0,0,1-.62-.06,3.26,3.26,0,0,0,3.06,2.28,6.63,6.63,0,0,1-4.08,1.4,6.6,6.6,0,0,1-.77,0A9.14,9.14,0,0,0,13,23","fill":"#fff","key":1})]);
}

SharetwitterhoverInline.defaultProps = {"id":"Calque_1","data-name":"Calque 1","viewBox":"0 0 32 32"};

module.exports = SharetwitterhoverInline;

SharetwitterhoverInline.default = SharetwitterhoverInline;
